import Swal from 'sweetalert2'
import {
  IconPaths,
  showAlertLoading,
  showError,
  validateDateRange,
} from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { SearchPersonModal } from '../../../../../../components/Modal/SearchPersonModal'
import { getCsvInterconsultasSolicitante } from '../../core/_requests'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import { useEscopoPareceres } from '../../core/escopoPareceres'

type Props = {
  /** Chamado quando falta o período (campo + datas): a busca destaca os campos obrigatórios. */
  onPeriodoIncompleto: () => void
}

export const PareceresListToolbar = ({ onPeriodoIncompleto }: Props) => {
  const { state } = useQueryRequest()
  const { filters } = useListFilters()
  const escopo = useEscopoPareceres()
  const { showModal } = useModal()

  const periodoValido =
    !!(filters.range && filters.dataInicial && filters.dataFinal) &&
    !validateDateRange(filters.dataInicial, filters.dataFinal, { maxRangeDays: 31 }).error

  const handleInterconsulta = () =>
    showModal({
      title: 'Localizar Paciente',
      content: <SearchPersonModal forcedEntityType='interconsulta' />,
    })

  // A lista da equipe é só de acompanhamento: CSV e nova solicitação ficam nas próprias.
  if (escopo === 'equipe') return null

  // Mesma busca da tabela, sem paginação/ordenação. A rota do CSV, como a da tabela, já restringe
  // às interconsultas do solicitante logado.
  const exportarCsv = async () => {
    if (!periodoValido) {
      onPeriodoIncompleto()
      return
    }

    try {
      showAlertLoading()
      const { data } = await getCsvInterconsultasSolicitante(`search=${state.search ?? ''}`)
      Swal.close()
      window.open(data.URL, '_blank')
    } catch (error) {
      showError(error)
    }
  }

  return (
    <>
      <Button
        variant='secondary-outline'
        icon={IconPaths.Csv}
        onClick={exportarCsv}
        title={periodoValido ? undefined : 'Informe o período para exportar'}
      >
        Exportar CSV
      </Button>
      <Button className='btn-primary' icon={IconPaths.Add} onClick={handleInterconsulta}>
        Solicitar parecer
      </Button>
    </>
  )
}
